<ng-container [formGroup]="addCoveredAreaSubcontractorForm">
  <div class="card-body body-wrapper">
    <h2>Covered Areas</h2>
    <div class="form-row ">
      <!--<div class="form-group col-12">
      <label for="states" class="custom_label">States</label>
      <ng-select
        id="states"
        [items]="states"
        placeholder="Select States"
        [closeOnSelect]="true"
        [multiple]="false"
        formControlName="states"
        bindLabel="{{coreService.ngSelectBindLabel}}"
        (change)="selectedStates($event)"
        >
      </ng-select>
    </div>-->

    <div class="form-group col-12">
      <label for="states">States</label>
      <div class="row flx-11">
        <div class="col-11">
          <ng-select
            id="states"
            [items]="states"
            placeholder="Select States"
            [closeOnSelect]="true"
            [multiple]="false"
            formControlName="states"
            bindLabel="{{coreService.ngSelectBindLabel}}"
            >
          </ng-select>
        </div>
        <div class="col-1">
          <span class="plus-icon-select" (click)="selectedStates($event)">+</span>
        </div>
      </div>
      <!--        <app-validation-error [formGroup]="proposalScopeProductForm" [controlName]="'vendor'"></app-validation-error>-->
    </div>

  </div>
  <ng-container formArrayName="covered_areas">
    @for (area of areas().controls; track area; let i = $index) {
      <div class="form-row">
        <div class="form-group col-12" [formGroupName]="i">
          <label for="covered_areas" class="custom_label d-flex justify-content-between">
            <span>Add Covered Area for {{areas().at(i).get('state_name')?.value}}</span>
            <a href="javascript:void(0);" (click)="removeState(i)" class="remove">
              <img src="../../../../assets/img/cross_icon.svg" alt="" class="icon">
            </a>
          </label>
          <div class="row">
            <div class="col-11">
              <input matInput type="text" (keydown.enter)="$event.preventDefault();addZipCode($event, i);" (keyup.enter)="$event.preventDefault();addZipCode($event, i);" id="covered_areas" formControlName="zipcode" class="form-control" placeholder="Covered Areas" name="covered_areas">
            </div>
            <div class="col-1">
              <span class="plus-icon-select" (click)="addZipCode($event, i)">+</span>
            </div>
          </div>
        </div>
        <div class="tags mt-3">
          <mat-chip-listbox >
            @for (area of areas().at(i).get('covered_areas')?.value; track area) {
              <mat-chip-option>
                {{area}}
                <button matChipRemove (click)="removeArea(area,i)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      </div>
    }
  </ng-container>

</div>
</ng-container>
